/** The search shortcut as this computer writes it: ⌘K on Apple devices, Ctrl K elsewhere. */
export const shortcutLabel = () =>
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent) ? '⌘K' : 'Ctrl K';
